function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import Modal from "react-modal";
import BackButton from "web/react/components/buttons/back-button/back-button";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./overlay.css";

function Overlay(_ref) {
  var children = _ref.children,
      contentClassName = _ref.contentClassName,
      isOpen = _ref.isOpen,
      onBack = _ref.onBack,
      onOverlayClick = _ref.onOverlayClick,
      onRequestClose = _ref.onRequestClose,
      _ref$peek = _ref.peek,
      peek = _ref$peek === void 0 ? false : _ref$peek,
      title = _ref.title,
      customClose = _ref.customClose;
  var overlayRef = useRef(null);
  useEffect(function () {
    document.body.classList.toggle("no-scroll", isOpen);
    return function () {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);
  var appElement;

  if (document.body) {
    // The modal needs to know where the rest of the site's content is for
    //  accessability reasons, and it should all be in a div called
    //  .site-wrapper as a direct decendent of the body.
    // Some things (ie cookie banner) are not in that div but we can ignore
    //  that for now
    appElement = document.body.querySelector(".site-wrapper") || undefined;
  }

  function handleRequestClose(event) {
    // This check is if there is a different behaviour to close for when the users clicks the
    // overlay and close
    if (onOverlayClick && overlayRef.current && overlayRef.current.contains(event.target)) {
      onOverlayClick();
    } else {
      onRequestClose();
    }
  }

  function setOverlayRef(node) {
    overlayRef.current = node;
  }

  return React.createElement(Modal, {
    overlayClassName: {
      base: styles.background,
      afterOpen: styles.afterOpen,
      beforeClose: styles.beforeClose
    },
    className: {
      base: classnames(styles.overlay, _defineProperty({}, styles.peek, peek)),
      afterOpen: styles.afterOpen,
      beforeClose: styles.beforeClose
    },
    overlayRef: setOverlayRef,
    appElement: appElement,
    onRequestClose: handleRequestClose,
    closeTimeoutMS: 1000,
    isOpen: isOpen
  }, React.createElement("div", {
    className: styles.header
  }, React.createElement("span", {
    className: styles.back
  }, React.createElement(BackButton, {
    onClick: onBack ? onBack : onRequestClose
  })), React.createElement("span", {
    className: styles.title
  }, title), customClose || React.createElement("span", {
    className: styles.close
  }, React.createElement(CloseButton, {
    onClick: onRequestClose
  }))), React.createElement("div", {
    className: classnames(styles.content, contentClassName)
  }, children));
}

export default Overlay;
Overlay.propTypes = {
  children: PropTypes.node,
  contentClassName: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onBack: PropTypes.func,
  onRequestClose: PropTypes.func.isRequired,
  peek: PropTypes.bool,
  title: PropTypes.string.isRequired
};